import { ParentCategoryEnum } from "../types/enums.ts";


export function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function cleanDocumentFileName(file_name: string) {
    const filename = file_name.split('/').slice(-1)[0] || '';

    const longFormatMatch = filename.match(/^ENCR_[^_]*_[^_]*_(.*)$/);
    if (longFormatMatch) {
        return longFormatMatch[1];
    }

    const shortFormatMatch = filename.match(/^ENCR_(.*)$/);
    if (shortFormatMatch) {
        return shortFormatMatch[1];
    }

    return filename;
}

export function isTimeSetToMidnight(isoString: string): boolean {
    if (!isoString) return false;

    const date = new Date(isoString);
    if (isNaN(date.getTime())) return false;

    return date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0;
}

let timer;

export function debounce<T extends (...args: any[]) => void>(func: T, timeout = 1000) {
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}

export function getYesterdayDate(): string {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday.toISOString().split('T')[0];
}

const CATEGORY_TRANSLATIONS_BY_KEY: Record<string, string> = {
    [ParentCategoryEnum.BANKING_AND_INSURANCE.toLowerCase()]: "Bank & Verzekeringen",
    [ParentCategoryEnum.PROFESSIONAL_SERVICES.toLowerCase()]: "Professionele dienstverlening",
    [ParentCategoryEnum.CAR_AND_EQUIPMENT.toLowerCase()]: "Auto & Apparatuur",
    [ParentCategoryEnum.REVENUE.toLowerCase()]: "Inkomsten",
    [ParentCategoryEnum.INTERNAL_TRANSFERS.toLowerCase()]: "Interne Overboekingen",
    [ParentCategoryEnum.OFFICE_COSTS.toLowerCase()]: "Kantoorkosten",
    [ParentCategoryEnum.OTHER_EXPENSES.toLowerCase()]: "Overige kosten",
    [ParentCategoryEnum.PRIVATE_WITHDRAWALS.toLowerCase()]: "Privé-opnames",
    [ParentCategoryEnum.PAYROLL_TAX_RECEIVABLE.toLowerCase()]: "Terug te ontvangen Loonbelasting",
    [ParentCategoryEnum.PERSONNEL_COSTS.toLowerCase()]: "Personeelskosten",
    [ParentCategoryEnum.RENT_AND_FACILITIES.toLowerCase()]: "Huur & Faciliteiten",
    [ParentCategoryEnum.COST_OF_GOOD_SOLD.toLowerCase()]: "Inkoopkosten",
    [ParentCategoryEnum.SALES_AND_MARKETING.toLowerCase()]: "Verkoop & Marketing",
    [ParentCategoryEnum.TAXES.toLowerCase()]: "Belastingen",
    [ParentCategoryEnum.SOFTWARE.toLowerCase()]: "Software",
    [ParentCategoryEnum.PAYMENT_REQUESTS.toLowerCase()]: "Betalingsverzoeken",
    [ParentCategoryEnum.UNCATEGORIZED.toLowerCase()]: "Ongecategoriseerd",
    [ParentCategoryEnum.INT_NON_OPERATIONAL.toLowerCase()]: "INT_Niet-operationeel",
    // New Categories Only
    [ParentCategoryEnum.VAT_PAYABLE.toLowerCase()]: "Te betalen BTW",
    [ParentCategoryEnum.VAT_RECEIVABLE.toLowerCase()]: "Terug te ontvangen BTW",
    [ParentCategoryEnum.PAYROLL_TAX_PAYABLE.toLowerCase()]: "Te betalen Loonbelasting",
    [ParentCategoryEnum.INCOME.toLowerCase()]: "Inkomsten",
    [ParentCategoryEnum.BUSINESS_SERVICES.toLowerCase()]: "Zakelijke dienstverlening",
    [ParentCategoryEnum.OTHER_COSTS.toLowerCase()]: "Overige kosten",
    [ParentCategoryEnum.PURCHASE_COSTS.toLowerCase()]: "Inkoopkosten",
    [ParentCategoryEnum.OWNERS_CURRENT_ACCOUNT.toLowerCase()]: "Rekening-courant eigenaar",
    [ParentCategoryEnum.INVESTMENT.toLowerCase()]: "Investering",
    [ParentCategoryEnum.FINANCING.toLowerCase()]: "Financiering",
};

export function translateEnglishCategoryToDutch(englishWord: string) {
    if (!englishWord) {
        return CATEGORY_TRANSLATIONS_BY_KEY[ParentCategoryEnum.UNCATEGORIZED.toLowerCase()];
    }

    const normalizedKey = englishWord.toLowerCase();

    return CATEGORY_TRANSLATIONS_BY_KEY[normalizedKey] ?? englishWord;
}
